export default __webpack_public_path__ + "static/media/img-ltsh-2.5eb5094a.png";